<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ legal_entity_data.short_name }}</h1>
        <div class="status-title" :style="{ 'backgroundColor': legal_entity_data.active ? '#77b017' : '#5f5f5f' }">
          {{ legal_entity_data.active ? 'Active' : 'Hide' }}
        </div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Name:</span><span>{{ legal_entity_data.name }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full info-cards__row-item--flex-start">
              <span>Address:</span><span>{{ legal_entity_data.address || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view :legalEntityData="legal_entity_data" />
      </transition>
    </template>
  </div>
</template>

<script>

import { getAdministrativeLegalEntity } from '@/http'
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'AdministrativeLegalEntitiesDetailLayout',
  components: { AppTabs },
  data() {
    return {
      page_loaded: false,
      legal_entity_data: {},
      tabs: [
        { name: 'administrative-legal-entities-detail-licenses', label: 'Licenses' },
        { name: 'administrative-legal-entities-detail-insurances', label: 'Insurances' },
      ],
    }
  },
  created() {
    getAdministrativeLegalEntity(this.$route.params.id)
      .then(res => {
        this.legal_entity_data = res.data
        this.page_loaded = true
      })
  },
}
</script>
